export default __webpack_public_path__ + "static/media/checkok.de8e158e.svg";